/* HeroCardSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJa6YE%7Bgrid-area%3Acontent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr07p2s%7Balign-self%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { Card } from '../Card/Card';
import { CardCover } from '../Card/CardCover';
import { HeroCard } from './HeroCard';
const styles = {
  content: "_1xC2CJa6YE _4xdlr07p2s _4ouGXIdnbC"
};
const LoadingAvatar = (): React.JSX.Element => <Skeleton width={48} height={48} />;
export const HeroCardSkeleton = ({
  testId
}: {
  testId?: string;
}): React.JSX.Element => <HeroCard testId={testId} summary={<Stack space="space.100" aria-hidden="true">
				<Skeleton width="100%" height={16} />
				<Skeleton width="90%" height={16} />
				<Skeleton width="60%" height={16} />
			</Stack>}>
		<Card isDisabled aria-hidden="true">
			<CardCover name="" avatar={LoadingAvatar} coverStyle="plain" />
			<Stack xcss={styles.content} space="space.100">
				<Skeleton width="70%" height={16} />
				<Skeleton width="45%" height={12} />
			</Stack>
		</Card>
	</HeroCard>;